import React from "react";
import "./MapModal.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

const MapModal = ({ show, onClose, lat, lng, name }) => {
  if (!show) return null;

  return (
    <div className="map-overlay" onClick={onClose}>
      <div
        className="map-modal"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <button className="close-btn" onClick={onClose}>✖</button>

        <h5 className="map-title">{name}</h5>

        <MapContainer
          center={[lat, lng]}
          zoom={14}
          style={{ height: "350px", width: "100%", borderRadius: "12px" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[lat, lng]}>
            <Popup>{name}</Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};

export default MapModal;
